import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=442265b0&"
import script from "./Pago.vue?vue&type=script&lang=js&"
export * from "./Pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports